
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class InputText extends Vue {
  @Prop({ default: '' }) wrapperInputClass: string;
  @Prop({ default: 'Label' }) label!: string;
  @Prop({ default: '' }) value!: string;
  @Prop({ default: '' }) placeholder!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: true }) outlined!: boolean;
  @Prop({ default: 'text' }) type!: string;
  @Prop({ default: '' }) prependIcon!: string;
  @Prop({ default: 'mdi-search' }) appendIcon!: string;
  @Prop({ default: 'Enviar' }) buttonText!: string;


  @Emit()
  onAppendIconClick() {}

  @Emit()
  onPrependIconClick() {}

  @Emit()
  onButtonClick() {}
}
